import {Col, Form, InputGroup, Row} from "react-bootstrap";

function AdditionalOptionsCell(props) {
    const job = props.job;

    function handleBindingChecked(e) {
        job.isBinding.set(e.target.checked);

        if (!e.target.checked) {
            job.bindingLoc.set(null);
            job.bindingStyle.set(null);
        }
    }

    function handleBindingSelection(setting, value) {
        if (setting === 'style') {
            job.bindingStyle.set(value.toLowerCase());
        } else if (setting === 'loc') {
            job.bindingLoc.set(value.toLowerCase());
        }
    }

    function handlePaddingChecked(e) {
        job.isPadding.set(e.target.checked);

        if (!e.target.checked) {
            job.paddingSetsOf.set('');
        }
    }

    function handlePerfChecked(e) {
        job.isPerfed.set(e.target.checked);

        if (!e.target.checked) {
            job.perfStyle.set('');
        }
    }

    function handlePunchChecked(e) {
        job.isPunched.set(e.target.checked);

        if (!e.target.checked) {
            job.punchingLoc.set('');
            job.punchingStyle.set('');
        }
    }

    function handleNumberingChecked(e) {
        job.isNumbered.set(e.target.checked);

        if (!e.target.checked) {
            job.numberingNumbers.set('');
            job.numberingLoc.set('');
        }
    }

    function handleRoundCornersChecked(e) {
        job.isRoundCorner.set(e.target.checked);

        if (!e.target.checked) {
            job.roundCornerLoc.set('');
        }
    }

    return (
        <div id={'additionalOptionsSection'}>
            <Row id={'generic'}>
                <div className="form-check">
                    <input type="checkbox" className="form-check-input" id={`scoring`}
                           onChange={e => job.isScoring.set(e.target.checked)} checked={job.get().isScoring} />
                    <label className="form-check-label" htmlFor={`scoring`}>Scoring</label>
                </div>
                <div className="form-check">
                    <input type="checkbox" className="form-check-input" id={`diecut`}
                           onChange={e => job.isDiecut.set(e.target.checked)} checked={job.get().isDiecut} />
                    <label className="form-check-label" htmlFor={`diecut`}>Diecut</label>
                </div>
                <div className="form-check">
                    <input type="checkbox" className="form-check-input" id={`flat`}
                           onChange={e => job.isFlat.set(e.target.checked)} checked={job.get().isFlat} />
                    <label className="form-check-label" htmlFor={`flat`}>Flat</label>
                </div>
                <div className="form-check">
                    <input type="checkbox" className="form-check-input" id={`glue`}
                           onChange={e => job.isGlue.set(e.target.checked)} checked={job.get().isGlue} />
                    <label className="form-check-label" htmlFor={`glue`}>Glue</label>
                </div>
            </Row>

            <Row id={'nonGeneric'}>
                <Col className={'cell'} id={'bindingCell'} sm={2}>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" id={`binding`}
                               onChange={handleBindingChecked} checked={job.get().isBinding} />
                        <label className="form-check-label header" htmlFor={`binding`}>Binding</label>
                    </div>
                    <div id={'bindingOptions'}>
                        <div id={'bindingStyles'}>
                            {['Perfect', 'Saddle', 'GBC'].map((style, _idx) => {
                                return (
                                    <label key={_idx}>
                                        <Form.Check name={`bindStyle`}
                                                    id={`${style}`}
                                                    type={'radio'}
                                                    onClick={() => handleBindingSelection('style', style)}
                                                    disabled={!job.isBinding.get()}
                                                    checked={job.get().bindingStyle === style.toLowerCase()}
                                        />
                                        {style}
                                    </label>
                                )
                            })}
                        </div>
                        <div id={'bindingLocations'}>
                            {['Top', 'Side', 'Bottom'].map((loc, _idx) => {
                                return (
                                    <label key={_idx}>
                                        <Form.Check name={`bindLoc`}
                                                    id={`${loc}`}
                                                    type={'radio'}
                                                    onClick={() => handleBindingSelection('loc', loc)}
                                                    disabled={!job.isBinding.get()}
                                                    checked={job.get().bindingLoc === loc.toLowerCase()}
                                        />
                                        {loc}
                                    </label>
                                )
                            })}
                        </div>
                    </div>
                </Col>

                <Col className={'cell'} id={'paddingCell'} sm={2}>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" id={`padding`}
                               onChange={handlePaddingChecked} checked={job.get().isPadding} />
                        <label className="form-check-label header" htmlFor={`padding`}>Padding</label>
                    </div>
                    <InputGroup>
                        <InputGroup.Append><InputGroup.Text>Sets of</InputGroup.Text></InputGroup.Append>
                        <Form.Control name={`paddingSets`}
                                      className={'specInput'}
                                      onChange={e => job.paddingSetsOf.set(e.target.value)}
                                      value={job.paddingSetsOf.get()}
                                      disabled={!job.isPadding.get()} />
                    </InputGroup>
                </Col>

                <Col className={'cell'} id={'perforationsCell'} sm={2}>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" id={`perf`}
                               onChange={handlePerfChecked} checked={job.get().isPerfed} />
                        <label className="form-check-label header" htmlFor={`perf`}>Perforations</label>
                    </div>
                    <Form.Label>
                        <Form.Check type={"radio"}
                                    name={`perf`}
                                    id={`perfStub`}
                                    onClick={() => job.perfStyle.set('Stub')}
                                    disabled={!job.isPerfed.get()}
                                    checked={job.perfStyle.get() === 'Stub'}
                        />
                        Stub
                    </Form.Label>
                    <Form.Label>
                        <Form.Check type={"radio"}
                                    name={`perf`}
                                    id={`perfOther`}
                                    onClick={() => job.perfStyle.set('Other')}
                                    disabled={!job.isPerfed.get()}
                                    checked={job.perfStyle.get() === 'Other'}
                        />
                        Other
                    </Form.Label>
                </Col>

                <Col className={'cell'} id={'punchingCell'} sm={2}>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" id={`punching`}
                               onChange={handlePunchChecked} checked={job.get().isPunched} />
                        <label className="form-check-label header" htmlFor={`punching`}>Punching</label>
                    </div>
                    <InputGroup>
                        <InputGroup.Append><InputGroup.Text>Location</InputGroup.Text></InputGroup.Append>
                        <Form.Control name={`punch_location`}
                                      className={'specInput'}
                                      onChange={e => job.punchingLoc.set(e.target.value)}
                                      value={job.punchingLoc.get()}
                                      disabled={!job.isPunched.get()} />
                    </InputGroup>
                    <InputGroup>
                        <InputGroup.Append><InputGroup.Text>Style</InputGroup.Text></InputGroup.Append>
                        <Form.Control name={`punch_style`}
                                      className={'specInput'}
                                      onChange={e => job.punchingStyle.set(e.target.value)}
                                      value={job.punchingStyle.get()}
                                      disabled={!job.isPunched.get()} />
                    </InputGroup>
                </Col>

                <Col className={'cell'} id={'numberingCell'} sm={2}>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" id={`numbering`}
                               onChange={handleNumberingChecked} checked={job.get().isNumbered} />
                        <label className="form-check-label header" htmlFor={`numbering`}>Numbering</label>
                    </div>
                    <InputGroup>
                        <InputGroup.Append><InputGroup.Text>Location</InputGroup.Text></InputGroup.Append>
                        <Form.Control name={`numbering_location`}
                                      className={'specInput'}
                                      onChange={e => job.numberingLoc.set(e.target.value)}
                                      value={job.numberingLoc.get()}
                                      disabled={!job.isNumbered.get()} />
                    </InputGroup>
                    <InputGroup>
                        <InputGroup.Append><InputGroup.Text>Numbers</InputGroup.Text></InputGroup.Append>
                        <Form.Control name={`numbering_numbers`}
                                      className={'specInput'}
                                      onChange={e => job.numberingNumbers.set(e.target.value)}
                                      value={job.numberingNumbers.get()}
                                      disabled={!job.isNumbered.get()} />
                    </InputGroup>
                </Col>

                <Col className={'cell'} id={'roundCornersCell'} sm={2}>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" id={`rounded`}
                               onChange={handleRoundCornersChecked} checked={job.get().isRoundCorner} />
                        <label className="form-check-label header" htmlFor={`rounded`}>Round Corners</label>
                    </div>
                    <InputGroup>
                        <InputGroup.Append><InputGroup.Text>Location</InputGroup.Text></InputGroup.Append>
                        <Form.Control name={`roundCornersLoc`}
                                      className={'specInput'}
                                      onChange={e => job.roundCornerLoc.set(e.target.value)}
                                      value={job.roundCornerLoc.get()}
                                      disabled={!job.isRoundCorner.get()} />
                    </InputGroup>
                </Col>
            </Row>
        </div>
    )
}

export default AdditionalOptionsCell;